export const getCountries = function () {
    return `/countries`;
};
export const getCountryByCoordinate = function (latitude, longitude) {
    return `/countries/${latitude}/${longitude}`;
};
